import { NO_ELEMENT, rm } from 'utils';
import { Button } from 'components/Button';
import { NotifyLink } from 'components/Shared/NotifyLink';
import Image from 'components/Shared/Image';
import styles from './packageProduct.scss';
import Price, { RegularPrice } from 'components/Shared/Price';
import { getPackage, showPackageAndSavings } from './selector';
import { ProductSection } from './productSection';
import { IconArrow } from 'components/Shared/Icon/themes/BGH-RD3/iconArrow';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { AccordionSection } from 'components/Accordion';
import { PackageProduct as PackageProductModel } from 'models/PackageProduct';
import { isDesktopLayout } from 'components/Shared/responsive';
import sizes from 'config/sizes.json';
import { Title } from 'components/Shared/Product';

const IMAGE_SIZES = [
  { width: 100, height: 100 },
  { width: 140, height: 140 }
];
const IMAGE_DIMENSIONS = sizes.productPage.packageProduct;

const getShowAndSavings = createSelector(getPackage, showPackageAndSavings);
const PackageProduct = (props: PackageProductModel) => {
  const { productImage, products, price, url } = props;
  const desktop = useSelector(isDesktopLayout);
  return (
    <>
      <div className={styles.image}>
        <Image
          paddingBottom
          {...IMAGE_SIZES[+desktop]}
          responsive={IMAGE_DIMENSIONS}
          {...productImage}
        />
      </div>
      <Title {...props} isCategoryBold />
      <ul className={styles.products}>
        {products.map(p => (
          <li key={p.productId} className={styles.productItem}>
            <span>
              {p.quantity.amount} {p.quantity.unit}
            </span>
            &nbsp;
            <NotifyLink ticket={p.ticket} url={p.url}>
              {p.title}
            </NotifyLink>
          </li>
        ))}
      </ul>
      <div className={styles.package}>
        <div className={styles.price}>
          <Price className={styles.listPrice} price={price.listPrice} />
          {price.originalPrice && (
            <RegularPrice
              price={price.originalPrice}
              className={styles.originalPrice}
              unit={':-'}
              appearance="discount"
            />
          )}
        </div>
        <div className={styles.product}>
          <Button size="medium" href={url} appearance="tertiary" className={styles.borderButton}>
            {rm('product_part_of_package_goto')}
            <IconArrow className={styles.arrow} />
          </Button>
        </div>
      </div>
    </>
  );
};

export const DesktopPackageProduct = () => {
  const packageProduct = useSelector(getPackage);
  const { show, savings } = useSelector(getShowAndSavings);

  if (!show || packageProduct === undefined) {
    return NO_ELEMENT;
  }
  return (
    <ProductSection
      classNames={{
        wrapper: styles.desktopWrapper
      }}
      title={
        <h3>
          <span className={styles.header}>{rm('product_part_of_package_header')} &mdash;</span>
          <span className={styles.savings}>
            {rm('product_part_of_package_header_savings', savings)}
          </span>
        </h3>
      }
    >
      <PackageProduct {...packageProduct} />
    </ProductSection>
  );
};

export const MobilePackageProduct = () => {
  const packageProduct = useSelector(getPackage);
  const { show, savings } = useSelector(getShowAndSavings);

  if (!show || packageProduct === undefined) {
    return NO_ELEMENT;
  }
  return (
    <AccordionSection
      force="open"
      title={
        <>
          {rm('product_part_of_package_header')} &mdash;
          <span className={styles.savings}>
            {rm('product_part_of_package_header_savings', savings)}
          </span>
        </>
      }
    >
      <PackageProduct {...packageProduct} />
    </AccordionSection>
  );
};
